<template>
  <div class="columns">
    <div class="column conflict-column">
      <label class="label">Yours</label>
      <div class="table-wrapper">
        <table class="conflict-table">
          <thead>
            <tr>
              <th
                v-for="(header, colIndex) in headersLocal"
                :key="'local-header-' + colIndex"
              >
                <span class="cell-content" :title="header">
                  {{ header || ' ' }}
                </span>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(row, rowIndex) in dataRowsLocal"
              :key="'local-row-' + rowIndex"
            >
              <td
                v-for="(cell, colIndex) in row"
                :key="'local-cell-' + rowIndex + '-' + colIndex"
              >
                <span class="cell-content" :title="cell">{{ cell || '' }}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="column conflict-column">
      <label class="label">Theirs</label>
      <div class="table-wrapper">
        <table class="conflict-table">
          <thead>
            <tr>
              <th
                v-for="(header, colIndex) in headersServer"
                :key="'server-header-' + colIndex"
              >
                <span class="cell-content" :title="header">
                  {{ header || ' ' }}
                </span>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(row, rowIndex) in dataRowsServer"
              :key="'server-row-' + rowIndex"
            >
              <td
                v-for="(cell, colIndex) in row"
                :key="'server-cell-' + rowIndex + '-' + colIndex"
              >
                <span class="cell-content" :title="cell">{{ cell || '' }}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ConflictInstructionTableField',
  props: {
    local: { type: Array, default: () => [] },
    server: { type: Array, default: () => [] },
  },
  computed: {
    headersLocal() {
      return this.local[0] || [];
    },
    dataRowsLocal() {
      return this.local.slice(1);
    },
    headersServer() {
      return this.server[0] || [];
    },
    dataRowsServer() {
      return this.server.slice(1);
    },
  },
};
</script>

<style scoped>
.column.conflict-column {
  width: 50%;
  overflow-x: auto;
}

.table-wrapper {
  width: 100%;
  border: 1px solid #ccc;
  border-radius: 4px;
  overflow-x: auto;
}

.conflict-table {
  width: max-content; /* allows cells to grow up to their content size */
  table-layout: fixed;
  border-collapse: collapse;
  font-size: 0.85rem;
  background: white;
}

.conflict-table th,
.conflict-table td {
  border: 1px solid #ccc;
  padding: 4px 8px;
  text-align: center;
  min-width: 100px; /* each cell has enough room */
  max-width: 100px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.cell-content {
  display: block;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
